import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  background-color: black;
  position: relative;
  display: flex;
  background-color: black;
`;

export const Actions = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Frame = styled.iframe<{ isLoaded: boolean }>`
  width: 100%;
  height: 100%;
  border: none;
  background: black;
  opacity: ${(props) => (props.isLoaded ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;
